class SeoContent extends HTMLElement {
  constructor() {
    super();
    if(this.dataset.type != 'collapse') return;
    this.contentBottom = this.querySelector('.rm-seo-content-bot');
    this.button = this.querySelector('.rm-seo-content-button');
    if(this.button != null && this.contentBottom != null) {
      this.contentBottom.style.height = '0px';
      this.contentBottom.style.transition = 'height 150ms ease-in-out';
      this.contentBottom.style.overflow = 'hidden';
      this.button.addEventListener('click', this.toggle.bind(this));
    }
  }

  toggle() {
    this.button.classList.toggle('state--toggled');
    if(this.button.classList.contains('state--toggled')) {
      this.button.textContent = this.button.dataset.readLessText;
    } else {
      this.button.textContent = this.button.dataset.readMoreText;
    }
    this.toggleContent();
  }

  toggleContent() {
    this.contentBottom.style.height = this.contentBottom.style.height == '0px' ? this.contentBottom.scrollHeight + 'px' : '0px';
  }
}

customElements.define('seo-content', SeoContent);